module.exports = __webpack_public_path__ + "img/img_1209.12d9c308.jpg";